import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Language } from "../i18n";
import useAppState from "../state/app.state";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const { setLanguage } = useAppState();

  return (
    <Menu>
      <MenuButton as={Button}>{i18n.language}</MenuButton>
      <MenuList>
        {Object.keys(i18n.options.resources as object).map((language) => (
          <MenuItem
            key={language}
            onClick={() => setLanguage(language as Language)}
          >
            {language}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
